import { render, staticRenderFns } from "./modalUI.vue?vue&type=template&id=f1c94b18&scoped=true"
import script from "./modalUI.vue?vue&type=script&lang=js"
export * from "./modalUI.vue?vue&type=script&lang=js"
import style0 from "./modalUI.vue?vue&type=style&index=0&id=f1c94b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c94b18",
  null
  
)

export default component.exports